import { gql } from "@apollo/client";

export const LIST_SAVED_MIXES = gql`
  query mixes($projectID: ID!, $scenarioID: ID!) {
    mixes(projectID: $projectID, scenarioID: $scenarioID) {
      id
      name
      user {
        firstName
        lastName
        email
      }
      scenario {
        id
        name
        friendlyName
      }
      modelVersionID
      public
      createdAt
      payload
      updatedAt
    }
  }
`;

export const LIST_SCENARIOS = gql`
  query mixParentScenarios($projectId: ID!, $tenantId: ID!) {
    mixParentScenarios(projectId: $projectId, tenantId: $tenantId) {
      id
      name
      startDt
      endDt
      updatedAt
      lastModelVersionId
      friendlyName
      description
      lastWeekData
      pickerStart
      pickerEnd
    }
  }
`;

export const SAVE_MIX = gql`
  mutation saveMix(
    $tenantID: ID!
    $projectID: ID!
    $scenarioID: ID!
    $modelVersionID: ID!
    $name: String!
    $payload: String!
    $public: Boolean!
  ) {
    saveMix(
      tenantID: $tenantID
      projectID: $projectID
      scenarioID: $scenarioID
      modelVersionID: $modelVersionID
      name: $name
      payload: $payload
      public: $public
    ) {
      id
      name
      user {
        firstName
        lastName
        email
      }
      scenario {
        id
        name
        friendlyName
      }
      modelVersionID
      public
      payload
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_MIX = gql`
  mutation deleteMix($id: ID!) {
    deleteMix(id: $id)
  }
`;

export const UPDATE_MIX = gql`
  mutation updateMix(
    $mixID: ID!
    $scenarioID: String!
    $modelVersionID: ID!
    $name: String!
    $payload: String!
    $public: Boolean!
  ) {
    updateMix(
      mixID: $mixID
      scenarioID: $scenarioID
      modelVersionID: $modelVersionID
      name: $name
      payload: $payload
      public: $public
    ) {
      id
      name
      user {
        firstName
        lastName
        email
      }
      scenario {
        id
        name
      }
      modelVersionID
      public
      payload
      createdAt
      updatedAt
    }
  }
`;

export const MIX_RESOLVED_TARGETS = gql`
  query mixResolvedTargets($tenantId: ID!, $projectId: ID!, $scenarioId: ID!) {
    mixResolvedTargets(
      tenantId: $tenantId
      projectId: $projectId
      scenarioId: $scenarioId
    ) {
      id
      channelName
    }
  }
`;

export const MIX_CONTROL_VARIABLES = gql`
  query mixControlVariables($tenantId: ID!, $projectId: ID!, $scenarioId: ID!) {
    mixControlVariables(
      tenantId: $tenantId
      projectId: $projectId
      scenarioId: $scenarioId
    ) {
      groupName
    }
  }
`;
